define('views/notifications/dashboard',[
    'backbone',
    'views/_base/baseview',
    'text!views/notifications/dashboard.html',
    'views/shared/form/form_component'
], function(Backbone, BaseView, Template, FormComponent){
    'use strict';

    return BaseView.extend({
        className: 'profile-content',
        tagName  : 'div',
        isRender : true,
        needsAuth: false,
        template : _.template(Template),
        events   : {},

        initialize: function(options){
            options = options || {};

            this.wellness = pf.getFeature(enums.features.wellness);
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            this.notificationsPreferenceForm();

            return this;
        },

        notificationsPreferenceForm: function(){
            var that = this,
                form_fields = pf.getContent('profile.content.notifications.form.fields'),
                button_data = pf.getContent('profile.content.notifications.form.button_component'),
                route = pf.getContent('profile.content.notifications.form.route');

            if(_.isObject(form_fields)){

                this.notifications_form = new FormComponent({
                    elementName: '.js-profile-notifications-form',
                    button_data: button_data,
                    route      : route,
                    fields     : form_fields,
                    form_type  : enums.formType.standard,

                    validated  : function(fields, confirm){

                        // console.log('registration_form validated:',fields,confirm);

                        that.updatePreference();

                    },
                    success    : function(end){
                        // console.log('notificationsPreferenceForm success:',end);
                        // Route to next step or home
                        that.updatePreferenceSuccess();
                    },
                    error      : function(errors){
                        // console.log('notificationsPreferenceForm error:',errors);
                        that.updatePreferenceError();
                    }
                });

                this.getUpdatePreference();

            }

        },

        getUpdatePreference: function(){
            var that = this;

            $.ajax({
                url    : pf.userURL + '/preferences/',
                type   : 'GET',
                async  : false,
                contentType: 'application/json',
                success: function(response){
                    
                    that.preferences = response;
                    that.updateNotificationStatus();

                },
                error: function(error){
                    // console.log('getUpdatePreference error',error);
                }
            });

        },

        updateNotificationStatus: function(){
            var that = this;

            this.preferences.forEach(function(preference){

                if(preference.AID == enums.preference_type.pf_news_by_email){
                    that.notifications_form.updateFieldValue(enums.formComponentTypes.sms, preference.AV);
                }

                if(preference.AID == enums.preference_type.website_event_notification_by_mobile){
                    that.notifications_form.updateFieldValue(enums.formComponentTypes.marketing, preference.AV);
                }

            });

        },

        updatePreference: function(){
            var that = this,
                notification_form = this.notifications_form.getFieldValues(),
                data = [
                    {
                        AID: enums.preference_type.pf_news_by_email,
                        AV : notification_form.email_updates
                    },
                    {
                        AID: enums.preference_type.website_event_notification_by_mobile,
                        AV : notification_form.app_updates
                    }
                ];
            
            // console.log('updatePreference',data);

            $.ajax({
                url    : pf.userURL + '/preferences/',
                type   : 'POST',
                async  : false,
                contentType: 'application/json',
                data   : JSON.stringify(data),
                success: function(response){
                    
                    // console.log('updatePreference',response);

                    if(_.isFunction(that.notifications_form.acknowledgedValidation)){
                        that.notifications_form.acknowledgedValidation(true);
                    }

                },
                error: function(error){
                    // console.log('updatePreference error',error);

                    if(_.isFunction(that.notifications_form.acknowledgedValidation)){
                        that.notifications_form.acknowledgedValidation(false);
                    }
                }
            });

        },

        updatePreferenceSuccess: function(){
            // console.log('updatePreferenceSuccess');
            this.render();
        },

        updatePreferenceError: function(){
            // console.log('updatePreferenceError');
        },

        close: function(){}
    });
});

